/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ContactInputs */

const en_nav_contact = /** @type {(inputs: Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact`)
};

const tr_nav_contact = /** @type {(inputs: Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İletişim`)
};

/**
* | output |
* | --- |
* | "Contact" |
*
* @param {Nav_ContactInputs} inputs
* @param {{ locale?: "en" | "tr" }} options
* @returns {LocalizedString}
*/
export const nav_contact = /** @type {((inputs?: Nav_ContactInputs, options?: { locale?: "en" | "tr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ContactInputs, { locale?: "en" | "tr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_contact(inputs)
	return tr_nav_contact(inputs)
});